import { render, staticRenderFns } from "./CustomTitle.vue?vue&type=template&id=66bd929d&lang=pug&"
import script from "./CustomTitle.vue?vue&type=script&lang=js&"
export * from "./CustomTitle.vue?vue&type=script&lang=js&"
import style0 from "./CustomTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports